import VerificationAnnonces from "../VerificationAnnonces/VerificationAnnonces.jsx";

export default VerificationAnnonces;

